import React from 'react';
import './Footer.css';

// 页面底部 ICP 备案号（合规要求：中国大陆网站须公开展示备案号并链接到工信部备案查询）
export default function Footer() {
    return (
        <footer className="site-footer">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                陕ICP备2026022239号-1
            </a>
        </footer>
    );
}
